import gql from 'graphql-tag';
import {
  FULL_NOTE_FRAGMENT,
  GROUP_FRAGMENT,
  GROUP_MEMBER_FRAGMENT,
  SUBJECT_FRAGMENT,
  TRACKER_FRAGMENT
} from './fragments';

export const groupCreateOrUpdateMutation = gql`
  mutation GroupCreateOrUpdateMutation($input: CreateOrUpdateGroupInput!) {
    createOrUpdateGroup(input: $input) {
      group {
        ...GroupFields
      }
      errors {
        path
        message
      }
    }
  }
  ${GROUP_FRAGMENT}
`;

export const groupsQuery = gql`
  query GroupsQuery($notebookId: ID!) {
    groups(notebookId: $notebookId) {
      ...GroupFields
      parent {
        ...GroupFields
      }
      children {
        ...GroupFields
      }
      subjects {
        ...SubjectFields
      }
      trackers {
        ...TrackerFields
        subjects {
          ...SubjectFields
        }
        groups {
          ...GroupFields
        }
      }
    }
  }
  ${TRACKER_FRAGMENT}
  ${SUBJECT_FRAGMENT}
  ${GROUP_FRAGMENT}
`;

export const groupQuery = gql`
  query GroupQuery($id: ID!) {
    group(id: $id) {
      ...GroupFields
      parent {
        ...GroupFields
      }
      children {
        ...GroupFields
      }
      subjects {
        ...SubjectFields
      }
      trackers {
        ...TrackerFields
        subjects {
          ...SubjectFields
        }
        groups {
          ...GroupFields
        }
      }
    }
  }
  ${TRACKER_FRAGMENT}
  ${SUBJECT_FRAGMENT}
  ${GROUP_FRAGMENT}
`;

export const groupDataQuery = gql`
  query GroupDataQuery($slug: String!, $notebookId: ID!) {
    groupBySlug(slug: $slug, notebookId: $notebookId) {
      ...GroupFields
      trackers {
        ...TrackerFields
        subjects {
          ...SubjectFields
        }
      }
    }
  }
  ${TRACKER_FRAGMENT}
  ${SUBJECT_FRAGMENT}
  ${GROUP_FRAGMENT}
`;

export const groupBySlugQuery = gql`
  query GroupBySlugQuery($slug: String!, $notebookId: ID!) {
    groupBySlug(slug: $slug, notebookId: $notebookId) {
      ...GroupFields
      subjects {
        ...SubjectFields
      }
      trackers {
        ...TrackerFields
        subjects {
          ...SubjectFields
        }
        groups {
          ...GroupFields
        }
      }
    }
  }
  ${TRACKER_FRAGMENT}
  ${SUBJECT_FRAGMENT}
  ${GROUP_FRAGMENT}
`;

export const inviteMemberToGroupMutation = gql`
  mutation InviteMemberToGroupMutation($input: InviteMemberToGroupInput!) {
    inviteMemberToGroup(input: $input) {
      groupMember {
        id
      }
      errors {
        path
        message
      }
    }
  }
`;

export const removeMemberFromGroupMutation = gql`
  mutation RemoveMemberFromGroupMutation($input: RemoveMemberFromGroupInput!) {
    removeMemberFromGroup(input: $input) {
      groupMember {
        id
      }
      errors {
        path
        message
      }
    }
  }
`;

export const groupDeleteMutation = gql`
  mutation GroupDeleteMutation($id: ID!) {
    deleteGroup(id: $id) {
      errors {
        path
        message
      }
    }
  }
`;

export const groupMembersQuery = gql`
  query GroupMembersQuery($input: GroupMembersInput!) {
    groupMembers(input: $input) {
      ...GroupMemberFields
    }
  }
  ${GROUP_MEMBER_FRAGMENT}
`;

export const changeGroupMembershipPermissions = gql`
  mutation ChangeGroupMembershipPermissions($input: ChangeGroupMembershipPermissionsInput!) {
    changeGroupMembershipPermissions(input: $input) {
      groupMember {
        id
        member {
          id
          displayName
          membershipStatus
          roleType
        }
      }
      errors {
        path
        message
      }
    }
  }
`;
